import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@popmenu/common-ui';
import { FormattedMessage } from 'react-intl';
import { screenReaderOnly } from '../../../assets/jss/utils/screenReaderOnly';

const useStyles = makeStyles(_theme => ({
  srOnly: {
    ...screenReaderOnly,
  },
}));

const localHistory: string[] = [];

export const PageChangeHandler = () => {
  const classes = useStyles();
  const location = useLocation();
  const path = location.pathname ?? '/';

  useLayoutEffect(() => {
    // Prevent scroll reset when moving to/from dish modal
    const shouldScroll = !(path.includes('/dishes/') || localHistory[localHistory.length - 1]?.includes('/dishes/'));
    if (shouldScroll) {
      document.documentElement.scrollTo({
        behavior: 'instant',
        left: 0,
        top: 0,
      });
    }
    localHistory.push(path);
  }, [path]);

  return (
    <div
      aria-atomic="true"
      aria-live="polite"
      className={classes.srOnly}
      role="status"
    >
      <FormattedMessage
        defaultMessage="Navigated to {pageName} page."
        values={{
          pageName: path,
        }}
      />
    </div>
  );
};
